import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import EmergencyContactCard from '@/components/crisis/EmergencyContactCard';
import CountrySelector from '@/components/crisis/CountrySelector';
import LocationDetector from '@/components/crisis/LocationDetector';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export default function CrisisResources() {
  const navigate = useNavigate();
  const { t } = useTranslation('crisis');
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const [detectedCountry, setDetectedCountry] = useState<string>('United States');

  const activeCountry = selectedCountry || detectedCountry;

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-16">
        <div className="bg-gradient-to-br from-red-50 to-orange-50 min-h-full">
          <div className="container mx-auto px-4 py-8">
            <div className="max-w-4xl mx-auto mt-8">
              <h1 className="text-3xl md:text-4xl font-serif font-medium text-earth-900 text-center mb-6">
                {t('pageTitle')}
              </h1>

              <div className="mb-8">
                <LocationDetector
                  detectedCountry={detectedCountry}
                  onDetectedCountryChange={setDetectedCountry}
                />
                <CountrySelector
                  selectedCountry={selectedCountry}
                  onCountryChange={setSelectedCountry}
                  detectedCountry={detectedCountry}
                />
              </div>

              <EmergencyContactCard country={activeCountry} />

              <div className="mt-12 bg-white rounded-xl shadow-sm border border-earth-200 p-6 text-center">
                <p className="text-earth-700 mb-4">
                  {t('needRegularTherapy', 'Need regular therapy sessions?')}
                </p>
                <Button
                  onClick={() => {
                    sessionStorage.removeItem('booking_choice_made');
                    navigate('/booking-choice');
                  }}
                  variant="default"
                  size="lg"
                  className="bg-primary hover:bg-primary/90"
                >
                  {t('continueBooking')}
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </div>

              {/* Disclaimer */}
              <div className="mt-8 bg-muted/30 rounded-lg p-6">
                <p className="text-sm text-muted-foreground text-center">
                  {t('disclaimer')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
